const MlsServiceLogType = {
  CREATE: 0,
  UPDATE: 1,
};

export default MlsServiceLogType;
